<template>
  <v-row justify="center" class="ma-10 d-flex">
    <v-card
      class="ma-2 rounded-xl"
      max-width="320"
      height="325"
      v-for="work in works"
      :key="work.name"
      :href="work.url"
    >
      <v-img :src="work.src" max-height="150"></v-img>
      <v-divider></v-divider>
      <v-row class="mx-2">
        <v-card-title class="text-h5 mx-2 mt-5 pa-0">{{
          work.name
        }}</v-card-title>
        <p class="no-wrap mx-2 mt-auto">{{ work.detail }}</p>
        <v-chip-group class="d-flex align-self-end mb-6">
          <v-chip class="my-0 px-4" v-for="tag in work.tags" :key="tag">
            {{ tag }}
          </v-chip>
        </v-chip-group>
      </v-row>
    </v-card>
  </v-row>
</template>
<script>
export default {
  data: () => ({
    works: [
      {
        name: "Todoリスト",
        src: require("@/assets/img/works/todo.png"),
        url: "https://panman11111.github.io/vuejs_todo/",
        detail:
          "Vueを用いた簡単なTodoリストです。\nチュートリアルで作成しました。",
        tags: ["Vue"]
      },
      {
        name: "noteライクアプリ",
        src: require("@/assets/img/works/note-like.png"),
        url: "https://note-like-app.web.app/",
        detail:
          "VueとFirebaseを組み合わせたCrudアプリです。Google認証でログインし書き込みを行うことができます。",
        tags: ["Vue", "Firebase", "tailwind.css"]
      },
      {
        name: "ポートフォリオサイト",
        src: require("@/assets/img/works/portfolio.png"),
        url: "https://pan-s-portfolio.web.app/works",
        detail:
          "現在ご覧いただいているポートフォリオサイトです。VuetifyでUIを整えました。",
        tags: ["Vue", "Vuetify", "Vanta.js"]
      },
      {
        name: "匿名ブログ",
        src: require("@/assets/img/works/blog.png"),
        url: "https://panman11111-test-django.herokuapp.com/",
        detail:
          "現在ご覧いただいている匿名ブログです。VuetifyでUIを整えました。",
        tags: ["django", "Bootstrap","Heroku"]
      },
      {
        name: "顔認証＋人数推移グラフ",
        src: require("@/assets/img/works/face-count.png"),
        url: "https://share.streamlit.io/panman11111/streamlit_camera_app/app.py",
        detail:
          "学習済モデルで顔を検知し、人数推移をグラフ化するアプリケーションです。",
        tags: ["Opencv", "sckitlearn", "matplotlib"],
      },
      // {
      //   name: "",
      //   src: require(""),
      //   url: "",
      //   detail:
      //     "",
      //   tags: [""],
      // },
    ],
  }),
};
</script>
<style>
.no-wrap {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>